const GCB2StartPage = () => import('@/views/GCB2/StartPage.vue')
export default [
    {
        path: '/project/:id/GCB2/hotWindows',
        name: 'GCB2HotWindows',
        props: { dashboardType: 'hotWindows' },
        component: GCB2StartPage,
        // Горячие окна работают только на данных YCLIENTS — на других CRM недоступны
        requiresYClients: true,
        // requiredRoles здесь нет намеренно: checkRole('gcb2:hotWindows:view')
        // ходит в project.rolesSettings, который приезжает из per-project
        // redis-кэша прав на 24ч. На проектах с кэшем, прогретым до миграции
        // с правами, гард молча делал safeNext(from) — карточка виджета была
        // видна, а клик по ней не делал ничего. Тумблер isHotWindowsEnabled
        // маршрут не режет: без него страница показывает экран подключения.
    },
]
